import styled from "styled-components";
import { COLORS } from "../../../constants/colors";
import ShowcaseTable from "../../molecules/showcase/ShowcaseTable";
import ShowcaseSelectBox from "../../molecules/showcase/ShowcaseSelectBox";
import PublicPaging from "../../publics/PublicPaging";
import { ShowcaseTableCardProps } from "../../../constants/types";

const ShowcaseTableCard = (props: ShowcaseTableCardProps) => {
  return (
    <Container>
      <ShowcaseSelectBox
        option={props.option}
        categories={props.categories}
        render={props.render}
      />
      <ShowcaseTable data={props.data} page={props.page} />
      <PublicPaging dataLength={props.data.length} page={props.page} />
    </Container>
  );
};

export default ShowcaseTableCard;

const Container = styled.div`
  width: 60%;
  height: 100%;
  border: 0.2vw solid ${COLORS.lightGray};
  box-sizing: border-box;
  padding: 1%;

  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
`;
